import { useState } from "react";
import { Users } from "../../interfaces/UserInterface";
import { ListaInformesAuditoriasInternas } from "./ListaInformesAuditoriasInternas"
import { InformeAI } from "../../interfaces/PlanesInterface";
import { InformeAuditoriaInterna } from "./InformeIA";
import { UsuarioSinPrivilegios } from "../login/Alerts";


export const InformesAuditoriasInternas = ()=>{

    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;
    let permisos = false;

    if(user){
        if(user.Auditoria !== "0"){
            permisos = true;
        }
        if(user.Informes !== "0"){
            permisos = true;
        }
    }

    const [informeAuditoria, setInformeAuditoria] = useState<InformeAI>();
    const [update, setUpdate] = useState(false);

    return(
    <>
        {
            permisos?
            <div
                className="row justify-content-center align-items-start g-2"
            >
                <div className="col-2 ocultar-al-imprimir">
                    <ListaInformesAuditoriasInternas informeSelect={informeAuditoria} setInformeSelect={setInformeAuditoria} update={update}/>
                </div>
                <div className="col-10">
                    {
                        informeAuditoria?
                        <InformeAuditoriaInterna informe={informeAuditoria} update={update} setUpdate={setUpdate} setInformeSelect={setInformeAuditoria}/>
                        :
                        <div></div>
                    }
                </div>
            </div>
            :
            <UsuarioSinPrivilegios/>
            
        }
        
    </>
    )
}